import { Injectable } from '@angular/core';
import { XAPIHelperService } from './xAPI-helper.service';
import { NotesDataService } from './notes-data.service';
import { LastPageDataService } from './last-page-data.service';
import { DrawingDataService } from './drawing-data.service';
import { LoaderService } from 'modules/app/services/loader.service';

@Injectable()
export class AppUnloadTrackerService {

    constructor(
        private xAPIHelperService: XAPIHelperService,
        private notesDataService: NotesDataService,
        private lastPageDataService: LastPageDataService,
        private drawingDataService: DrawingDataService,
        private loaderService: LoaderService
    ) {
        this.beforeUnloadEventListener = this.beforeUnloadEventListener.bind(this);
     }

    init(){
        window && window.addEventListener('beforeunload', this.beforeUnloadEventListener);
    }

    destroy(){
        window && window.removeEventListener("beforeunload", this.beforeUnloadEventListener);
    }

    private async beforeUnloadEventListener(e) {
        let pendingNotesInLocalStorage = this.notesDataService.checkPendingDataInLocalStorage();
            let pendingDrawingsInLocalStorage = this.drawingDataService.checkPendingDataInLocalStorage();
            let pendingLastPageInLocalStorage = this.lastPageDataService.checkPendingDataInLocalStorage();

            if((this.checkPendingXAPICalls() > 0) || pendingNotesInLocalStorage || pendingDrawingsInLocalStorage || pendingLastPageInLocalStorage){

                // Cancel the event
                e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
                // Chrome requires returnValue to be set
                e.returnValue = '';
    
                // post pending notes to xAPI
                if(pendingNotesInLocalStorage){
                    this.notesDataService.postPendingNotesToXAPI();
                }

                // post pending drawings to xAPI
                if(pendingDrawingsInLocalStorage){
                    this.drawingDataService.postPendingDrawingsToXAPI();
                }

                // post pending last page to xAPI
                if(pendingLastPageInLocalStorage){
                    this.lastPageDataService.postPendingLastPageToXAPI();
                }

                // flushing xAPI statements from local storage
                await this.xAPIHelperService.flushStateAndStatement();

                this.loaderService.hideLoader();

            }
    }

    checkPendingXAPICalls(){
        return this.xAPIHelperService.getPendingXPICalls().length;
    }

}